import React, { useState, useEffect, useReducer } from 'react';

import { useSelector } from 'react-redux';
import { selectUser } from '@core/store/modules/session/sessionSelectors';
import { useLanguage } from 'Context/LanguageContext';
import { Link, Box, TextField, Typography, Tooltip, Stack, Chip } from "@mui/material";
import { Col } from 'react-bootstrap';
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { getInventoriesLinkedToAssetsRequest, deleteInventoriesLinkedToAssetsRequest, addLinkedInventoriesToTaskRequest } from '@core/api/asset/asset.service';
import { useDispatch } from 'react-redux';
import { useFielderSnackBar } from '~/FielderElements/useFielderSnackBar';

import AddIcon from '@assets/icons/plus.svg';
import DeleteIcon from '@mui/icons-material/Delete';
import PostAddIcon from '@mui/icons-material/PostAdd';
import LANGUAGE from 'FielderUtils/languages/fielderLanguages';
import SearchInventory from 'OldComponents/Inventory/SearchInventory';


const LinkAssetInventory = ({ setInventoryValue, inventoryToAdd, idAsset, setInventoriesLinked, 
	action, showInventorySearch, showDeleteIcon, idTask, reloadData, idAccountTask }) => {

	const lan = useLanguage();
	const dispatch = useDispatch();
	const user = useSelector(selectUser);
	const fielderMsg = useFielderSnackBar();

	const langCode = lan?.getLanguage?.() ?? LANGUAGE.en;
	const localeMap = {
		  [LANGUAGE.en]: MRT_Localization_EN,
		  [LANGUAGE.es]: MRT_Localization_ES,
		  [LANGUAGE.mx]: MRT_Localization_ES,
		  [LANGUAGE.latam]: MRT_Localization_ES,
		  [LANGUAGE.pt]: MRT_Localization_PT_BR,
		};
	
	const [inventoryList, setInventoryList] = useState([]);
	const [amount, setAmount] = useState(1);
	const [rowCount, setRowCount] = useState(0);
	const [globalFilter, setGlobalFilter] = useState("");
	const [columnFilters, setColumnFilters] = useState([]);
	const [tableAssetInventory, setTableAssetInventory] = useState([]);
	const [showTableMoreInfo, setShowTableMoreInfo] = useState(false);
	const [rowSelection, setRowSelection] = useState({});
	const [pagination, setPagination] = useState({
			pageIndex: 0, 
			pageSize: 10, 
	});

	useEffect(() => {

		if(showTableMoreInfo){
			getInventoriesLinkedToAssets();
		}	
	}, [pagination.pageIndex, pagination.pageSize, globalFilter]);
	
  
	useEffect(() => {
		if(showTableMoreInfo){
			getInventoriesLinkedToAssets();	
		}
	}, [showTableMoreInfo]);

	useEffect(() => {
		if(showDeleteIcon && setInventoriesLinked !== undefined){
			setInventoriesLinked(inventoryList);
			}
	}, [inventoryList]);
	
	useEffect(() => {
		if(showTableMoreInfo){
			setShowTableMoreInfo(false);
		}
	}, [idAsset]);


	const handleChange = (event) => {
		let value = event.target.value;
		value = value.replace(/[^0-9]/g, "");

		if (value.startsWith("0")) {
			value = value.replace(/^0+/, ""); 
		}

		if (value === "") {
			setAmount(value);
		} else {
			setAmount(parseInt(value));
		}
	};

	const addInventory = () => {
		if(inventoryToAdd && amount > 0){

			const inventory = {
				label: inventoryToAdd.label,
				amount: amount,
				value: inventoryToAdd.value
			};
			setInventoryList((prevList) => [...prevList, inventory]);
			
		}
		
	};

	const handleDelete = (id) => {
		setInventoryList((prevList) => prevList.filter((item) => item.value.id !== id));
	};

	const getInventoriesLinkedToAssets = async () => {
		console.log("me ejecute")
		const onSuccess = (response) => {
				if(response.success){
					
						let mergedList = [];
						if(response.inventoryLinkedToAsset && response.inventories.length){
							const amountMap = Object.fromEntries(response.inventoryLinkedToAsset.map(item => [item.id, item.amount]));
							mergedList = response.inventories.map(item => ({
							...item,
							amount: amountMap[item.id] ?? 0
							}));
						}

					setTableAssetInventory(mergedList ? mergedList : []);
					setRowCount(response.countInventories);
				}
			}

			const onError = (error) => {
				console.error("Error fetching inventories linked to asset:", error);
			}

			const body = { idAsset, filter: globalFilter, offset: pagination.pageIndex * pagination.pageSize, limit: pagination.pageSize, accountId: idAccountTask ?? user.idAccount };
			const loadingConfig = { dispatch, config: { allowTopBar: true } };
			getInventoriesLinkedToAssetsRequest(body, onSuccess, onError, loadingConfig);
	}


	const showMoreInformation = (e) => {
		e.preventDefault();
		setShowTableMoreInfo(!showTableMoreInfo);
	}

	const handleDeleteSelected = (selectedRows) => {
		const selectedIds = selectedRows.map((row) => ({
			id: row.original.id,
			amount: row.original.amount,
		}));

		const onSuccess = (response) => {
			if(response.success){
				setRowSelection({}); 
				getInventoriesLinkedToAssets();
			}
		}
		const onError = (error) => {
			console.error("Error deleting linked inventories:", error);
		}
		const loadingConfig = { dispatch, config: { allowTopBar: true } };
		deleteInventoriesLinkedToAssetsRequest({ inventoryLinkedToAsset: selectedIds, idAsset }, onSuccess, onError, loadingConfig);
	}


	const handleAddSelected = (selectedRows) => {
	  	const ids = selectedRows.map((row) => row.original.id);
		const body = { idInventories: ids, idTask, accountId: idAccountTask ?? user.idAccount };
		
		const onSuccess = (response) => {
			console.log("response", response);
			 fielderMsg({
				title: lan.myOperation, message: lan.messageUpdatedProfile,
				variant: 'success', closeButton: true, duration: 3000, });
			reloadData();
		}
		const onError = (error) => {
			console.error("Error adding linked inventories to task:", error);
		}
		const loadingConfig = { dispatch, config: { allowTopBar: false } };
	   	addLinkedInventoriesToTaskRequest( body, onSuccess, onError, loadingConfig);
	}

	const columns = [
		{
			accessorKey: "id",
			header: lan.id,
			Cell: ({ cell }) => (
				<Typography variant="body2">
					{cell.getValue()}
				</Typography>
			),
		},
		{
			accessorKey: "name",
			header: lan.name,
			Cell: ({ cell }) => (
				<Typography variant="body2">
					{cell.getValue()}
				</Typography>
			),
		},
		{
			accessorKey: "type",
			header: lan.type,
			Cell: ({ cell }) => (
				<Typography variant="body2">
					{cell.getValue()}
				</Typography>
			),
		},
		{
			accessorKey: "model",
			header: lan.model,
			Cell: ({ cell }) => (
				<Typography variant="body2">
					{cell.getValue()}
				</Typography>
			),
		},
		{
			accessorKey: "serialNumber",
			header: lan.serialNumber,
			Cell: ({ cell }) => (
				<Typography variant="body2">
					{cell.getValue()}
				</Typography>
			),
		},
		{
			accessorKey: "brand",
			header: lan.brand,
			Cell: ({ cell }) => (
				<Typography variant="body2">
					{cell.getValue()}
				</Typography>
			),
		},
		{
			accessorKey: "amount",
			header: lan.amount,
			Cell: ({ cell }) => (
				<Typography variant="body2">
					{cell.getValue()}
				</Typography>
			),
		}
	];


	return (
		<>
			<div className='row-12' >
				{showInventorySearch && (
					<div className='row-12 no-padding'>
						<Col xs={12}>
							<SearchInventory idAccount={user.idAccount} setInventoryValue={setInventoryValue} size={12}/>
						</Col>
					</div>
				)}

				{inventoryToAdd && (
					<>
					<div className='row mt-3 d-flex justify-content-center'>
						
						<Col xs={3}>
							<TextField
								fullWidth
								label={lan.amount}
								defaultValue={amount}
								onChange={handleChange}
							/>
						</Col >
						<Col xs={4} className='d-flex align-items-center'>
							<button className='AddForm-button' onClick={() => addInventory()}>
								<img src={AddIcon} alt='' />
								<span>{lan.addInventory}</span>
							</button>
						</Col>
					</div>

					<div className='row-12 d-flex justify-content-center mt-2'>
						<Stack direction="column" spacing={1} className="col-12">
							{inventoryList.map((inventory, index) => (
								<Chip
									key={index}
									label={ inventory.label +
										(inventory.amount >= 1 ? ` (x${inventory.amount})` : "")
									}
									variant="outlined"
									sx={{
										backgroundColor: "#dc5c87",
										color: "#ffffffff", 
										 "& .MuiChip-deleteIcon": {
											color: "#ffffffff", 
										},
										"& .MuiChip-deleteIcon:hover": {
										color: "#ffffffff", 
										},    
									}}
									onDelete={() => handleDelete(inventory.value.id)}
								/>
							))}
						</Stack>
					</div>
					</>
				)}



				{action === 'update' && (
				<>
				<div className='row-12 mb-2 mt-2'>
					<Link 
						href="#"
						onClick={showMoreInformation}
						sx={{
							color: "#1565c0",
							textDecoration: "underline",
							textDecorationColor: "#1565c0",
							"&:hover": {
								color: "#dc5c87",
								textDecorationColor: "#dc5c87"
							}
						}}
					>
						{lan.viewAssociatedInventories}
					</Link>
				</div>

				

				{showTableMoreInfo && (
					<div className='row-12'>
						<MaterialReactTable 
							columns={columns}
							data={tableAssetInventory}
							rowCount={rowCount}
							manualPagination
							enableGlobalFilter 
							enableColumnFilters
							state={{ pagination, globalFilter, rowSelection, columnFilters }}
							onRowSelectionChange={setRowSelection}
							onColumnFiltersChange={setColumnFilters} 
							onPaginationChange={setPagination}
							onGlobalFilterChange={setGlobalFilter}
							localization={localeMap[langCode]}
							enableRowSelection 
							renderTopToolbarCustomActions={({ table }) => {
							const selectedRows = table.getSelectedRowModel().flatRows;

								return (
								<Box className='ml-3 mt-2'>
									{showDeleteIcon ? (
										<Tooltip title={lan.delete}>
											<DeleteIcon 
												sx={{ mr: 1, color: selectedRows.length === 0 ? 'grey' : '#dc5c87', cursor:  selectedRows.length === 0 ? 'not-allowed' : 'pointer' }}
												onClick={() => handleDeleteSelected(selectedRows)}
												
												disabled={selectedRows.length === 0}
											/>
										</Tooltip>
										) : (
											<Tooltip title={lan.addInventory}>
												<PostAddIcon 
													sx={{ mr: 1, color: selectedRows.length === 0 ? 'grey' : '#dc5c87', cursor:  selectedRows.length === 0 ? 'not-allowed' : 'pointer' }}
													onClick={() => handleAddSelected(selectedRows)}
													
													disabled={selectedRows.length === 0}
												/>
											</Tooltip>
										)
									}
								</Box>
								);
							}}
							muiSelectCheckboxProps={({ row }) => ({
								sx: {
								color: "#dc5c87", 
								"&.Mui-checked": {
									color: "#dc5c87", 
								},
								},
							})}
							 muiTableHeadCellCheckboxProps={{
								sx: {
								color: '#dc5c87',
								'&.Mui-checked': {
									color: '#dc5c87',
								},
								},
							}}
							muiSelectAllCheckboxProps={{
								sx: {
								color: "#dc5c87", 
								"&.Mui-checked": {
									color: "#dc5c87",
								},
								"&.MuiCheckbox-indeterminate": {
									color: "#dc5c87", 
								},
								},
							}}
							
							
								
						/>
					</div>
				)}
				</>)}
			</div>
		</>
	);
};

export default LinkAssetInventory;